import { getAuthorizationTokens } from '@loggi/authentication-lib';

async function hasCognitoAuthToken() {
  const { idToken } = await getAuthorizationTokens();
  return !!idToken;
}

export default hasCognitoAuthToken;
